module.exports = __webpack_public_path__ + "static/SM2-4e96650b8d18e4a6fd3aa989c40c4216.png";